import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReportSchedule from './report-schedules.reducer';

export const selectReportScheduleState = createFeatureSelector<fromReportSchedule.ReportSchedulesFeatureState>(
  fromReportSchedule.reportSchedulesFeatureKey
);

export const selectReportFeature = createSelector(selectReportScheduleState, (feature) => feature.reportSchedules);
export const selectReportSchedules = createSelector(selectReportFeature, fromReportSchedule.selectAll);
export const selectLoadingState = createSelector(selectReportScheduleState, (state) => state.loading);
